module.exports = __webpack_public_path__ + "media/images/assigned-task-icon-88f81eb30ce51b28cd4345cba68c42e4.svg";